export default "__VITE_ASSET__DDq_s_N0__"